<script setup lang="ts">
import { computed, ref } from 'vue'
import { useDashboardStore } from '@/stores/dashboard'
import { DashboardKPIEnum } from '@/common/enums/dashboardKPIEnum'

const dashboardStore = useDashboardStore()

// Define the order of stats cards to display
const allowedStatsOrder = [
  DashboardKPIEnum.NEW_SITES,
  DashboardKPIEnum.DELETED_SITES,
  DashboardKPIEnum.LIVE_SITES,
  DashboardKPIEnum.DEV_SITES,
  DashboardKPIEnum.PAYING_CUSTOMERS,
  DashboardKPIEnum.DUE_COMMISSION,
  DashboardKPIEnum.CREDITS,
  DashboardKPIEnum.UNPAID_AMOUNT,
  DashboardKPIEnum.THEME_UPDATES,
  DashboardKPIEnum.PLUGIN_UPDATES,
]

// Filter and reorder stats based on the allowed list
const statisticsVerticalSimple = computed(() => {
  const statsMap = new Map(
    dashboardStore.stats
      .filter(stat => !stat.key.startsWith('wl-'))
      .map(stat => [stat.key, stat])
  )
  
  return allowedStatsOrder
    .map(key => statsMap.get(key))
    .filter(Boolean) // Remove any undefined entries
})

const statisticsWlVerticalSimple = computed(() => dashboardStore.stats.filter(stat=> stat.key.startsWith('wl-')))

const openTab = ref(0)
const tabs = [
  {
    title: 'Bionic',
    key:'bionic'
  },
  {
    title: 'WhiteLabel',
    key:'whitelabel'
  },
]
</script>
<template>
    <VCol cols="12">
      <VTabs v-model="openTab" class="v-tabs-pill" align-tabs="center">
        <VTab v-for="tab in tabs" :key="tab.key">
          <span>{{ tab.title }}</span>
        </VTab>
      </VTabs>
      <VWindow v-model="openTab" class="mt-6" >
        <VWindowItem key="bionic">
          <div class="stats-cards-container">
            <div
                v-for="(statistics, index) in statisticsVerticalSimple"
                :key="index"
                class="stats-card-wrapper"
            >
              <CardStatisticsVerticalSimple
                  v-bind="statistics"
                  :card-key="statistics.key"
              />
            </div>
          </div>
        </VWindowItem>
        <VWindowItem key="whiteLabel">
          <VRow>
            <VCol
                v-for="(statistics, index) in statisticsWlVerticalSimple"
                :key="index"
                md="3"
                cols="6"
            >
              <CardStatisticsVerticalSimple
                  v-bind="statistics"
                  :card-key="statistics.key"
              />
            </VCol>
          </VRow>
        </VWindowItem>
      </VWindow>
    </VCol>

</template>

<style scoped>
.stats-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.stats-card-wrapper {
  flex: 0 0 calc(20% - 13px);
  min-width: 0;
}

/* Responsive breakpoints */
@media (max-width: 1264px) {
  .stats-card-wrapper {
    flex: 0 0 calc(25% - 12px);
  }
}

@media (max-width: 960px) {
  .stats-card-wrapper {
    flex: 0 0 calc(50% - 8px);
  }
}

@media (max-width: 600px) {
  .stats-card-wrapper {
    flex: 0 0 100%;
  }
}
</style>
